// pipe: the ONE pure copy-to-clipboard helper (moved verbatim from @affine/core/utils/clipboard —
// the package is the SSOT now; core imports it back). Async Clipboard API first (HTTPS), then the
// `document.execCommand('copy')` fake-textarea fallback for non-secure contexts.
const createFakeElement = (text: string) => {
  const isRTL = document.documentElement.getAttribute('dir') === 'rtl';
  const fakeElement = document.createElement('textarea');
  // Prevent zooming on iOS
  fakeElement.style.fontSize = '12pt';
  // Reset box model
  fakeElement.style.border = '0';
  fakeElement.style.padding = '0';
  fakeElement.style.margin = '0';
  // Move element out of screen horizontally
  fakeElement.style.position = 'absolute';
  fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px';
  // Move element to the same position vertically
  const yPosition = window.pageYOffset || document.documentElement.scrollTop;
  fakeElement.style.top = `${yPosition}px`;

  fakeElement.setAttribute('readonly', '');
  fakeElement.value = text;

  return fakeElement;
};

function command(type: string) {
  try {
    return document.execCommand(type);
  } catch (err) {
    console.error(err);
    return false;
  }
}

const fakeCopyAction = (text: string, container = document.body) => {
  let success = false;

  const fakeElement = createFakeElement(text);
  container.append(fakeElement);

  try {
    fakeElement.select();
    fakeElement.setSelectionRange(0, fakeElement.value.length);
    success = command('copy');
  } catch (err) {
    console.error(err);
  }

  fakeElement.remove();

  return success;
};

// Probed per call, not at module scope: this module is reachable from the package index in
// non-DOM (node) test environments, where a top-level `navigator` access would throw on import.
const clipboardWriteTextIsSupported = () =>
  typeof navigator !== 'undefined' &&
  'clipboard' in navigator &&
  'writeText' in navigator.clipboard;

export const copyTextToClipboard = async (text: string) => {
  // 1. try using Async API first, works on HTTPS domain
  if (clipboardWriteTextIsSupported()) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.error(err);
    }
  }

  // 2. try using `document.execCommand`
  // https://github.com/zenorocha/clipboard.js/blob/master/src/actions/copy.js
  return fakeCopyAction(text);
};
